import createInterceptor from './Interceptor';
import apiUrls from '@/config/apiUrls';

const baseURL = apiUrls.DASHBOARD_API_URL;

const axiosInstance = createInterceptor({
  baseURL,
  withCredentials: true,
});

export default axiosInstance;

export const clearHeaders = () => {
  try {
    axiosInstance.defaults.headers.common = {};
  } catch {
    // If it breaks, we do nothing
  }
};
